import React from 'react';

import { Button, Typography } from '@mui/material';

import { DisclosureDeliveryTestIds } from '../../DisclosureDelivery.testIds';
import { getDateTimeFormat } from '../../DisclosureDelivery.utils';

const emptyCell = () => (
  <Typography data-truncated className="truncate" variant="regular14">
    N/A
  </Typography>
);

export const getScheduledTableConfig = ({ onCancelButtonClick, enableCancel }) => ({
  signerFullName: {
    label: 'Recipient',
    width: '16%',
    content: ({ signerFullName }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {signerFullName || '-'}
      </Typography>
    ),
  },
  status: {
    label: 'Status',
    width: '11%',
    content: ({ status }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {status || '-'}
      </Typography>
    ),
  },
  generatedDate: {
    label: 'Generated',
    width: '11%',
    content: ({ generatedDate }) => (
      <Typography data-truncated className="truncate" variant="regular14">
        {getDateTimeFormat(generatedDate)}
      </Typography>
    ),
    tooltip: 'The disclosures will be generated',
  },
  sentDate: { label: 'Sent', width: '11%', content: emptyCell },
  openedDate: { label: 'Opened', width: '11%', content: emptyCell },
  consentedDate: { label: 'Read', width: '11%', content: emptyCell },
  signedDate: { label: 'E-Signed', width: '11%', content: emptyCell },
  actions: {
    label: '',
    width: '18%',
    content: () =>
      enableCancel ? (
        <Button
          data-testid={DisclosureDeliveryTestIds.CANCEL_SENDING_BUTTON}
          onClick={onCancelButtonClick}
        >
          Cancel sending bundle
        </Button>
      ) : null,
  },
});
